import { string, shape, number, arrayOf } from 'prop-types';

import { picturePropTypes } from './pictures';
import { productsPropTypes } from './product';

export const itemsPropTypes = arrayOf(
  shape({
    basePrice: number.isRequired,
    count: number.isRequired,
    description: string.isRequired,
    id: number.isRequired,
    items: arrayOf(productsPropTypes).isRequired,
    name: string.isRequired,
    pictures: picturePropTypes.isRequired,
    specialRequirement: string
  })
);
